import React, {useState, useRef} from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios';
import endpoints, { getBackendUrl } from '../../../endpoints';
import { useSelector, useDispatch } from 'react-redux'
import CloseIcon from '@mui/icons-material/CloseRounded';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import DOMPurify from 'dompurify';

export default function SearchViewModal(props) {
    const rawMarkup = (content) => {
        var rawMarkup = content
        return { __html: DOMPurify.sanitize(rawMarkup) };
    }
        
    return (
        <Dialog open={props.dialogData ? true : false} fullWidth maxWidth="md" onClose={props.onClose}>
            <DialogTitle>
                {props.dialogData?.feed?.name} | {props.dialogData?.title}
                <IconButton
                    onClick={props.onClose}
                    sx={{
                      position: 'absolute',
                      right: 8,
                      top: 8,
                      color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Stack spacing={2}>
                    <Stack direction="row" spacing={1}>
                        {props.dialogData?.notes?.map((note, key) => {
                            if (note.type === 'checkbox') {
                                if (note.value) {
                                    return (
                                        <Chip 
                                            key={key}
                                            avatar={<CheckBoxOutlinedIcon style={{fill: "white"}} />}
                                            sx={{pl:'3px'}}
                                            size="small"
                                            color={note.value ? 'success' : 'default'}
                                            variant={note.value ? 'filled' : 'outlined'}
                                            label={note.title}
                                        />
                                    )
                                } else {
                                    return (
                                        <Chip 
                                            key={key}
                                            avatar={<CheckBoxOutlineBlankOutlinedIcon />}
                                            sx={{pl:'3px'}}
                                            size="small"
                                            color={note.value ? 'success' : 'default'}
                                            variant={note.value ? 'filled' : 'outlined'}
                                            label={note.title}
                                        />
                                    )
                                }
                            } else {
                                return (
                                    <Chip 
                                        key={key}
                                        size="small"
                                        color={note.value ? 'success' : 'default'}
                                        variant={note.value ? 'filled' : 'outlined'}
                                        label={(note.value ? note.title + ': ' + note.value : note.title)}
                                    />
                                )
                            }
                        })}
                        
                        {props.dialogData?.archived ?
                        <Stack direction="row" sx={{ flexGrow: 1}}>
                            <Stack direction="row" sx={{ flexGrow: 1}} />
                            <Chip 
                                size="small"
                                color="primary"
                                variant="outlined"
                                label="archived"
                            />
                        </Stack>
                        : null }
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={1}>
                        {props.dialogData?.tags?.map((tag, key) => (
                            <Chip key={key} label={tag.name} size="small" />
                        ))}
                    </Stack>
                    <div style={{marginTop: '1.5rem', paddingBottom: '30px'}} dangerouslySetInnerHTML={rawMarkup(props.dialogData?.content)} />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    )
}